import React, { useState, useEffect } from 'react';
import { client } from '../../../Sanityclient';
import { AppLearnMoreWrap, MotionWrap } from '../../../wrapper';
import styled from 'styled-components';
import { EducationCard } from '../../../components/Cards';
import { VerticalTimeline } from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';

const Container = styled.div`
margin-top: 100px;
display: flex;
flex-direction: column;
justify-content-center;
position: relative;
z-index: 1;
align-items: center;
`;
const Wrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  width: 100%;
  max-width: 1100px;
  gap: 12px;
  @media (max-width: 960px) {
    flex-direction: column;
  }
`;

const Title = styled.div`
  font-size: 52px;
  text-align: center;
  font-weight: 600;
  margin-top: 20px;
  color: #F2F3F4};
  @media (max-width: 768px) {
    margin-top: 12px;
    font-size: 32px;
  }
`;

const Desc = styled.div`
  font-size: 18px;
  text-align: center;
  font-weight: 600;
  color: #b1b2b3};
  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

const Education = () => {
  const [education, setEducation] = useState([]);

  useEffect(() => {
    const query = '*[_type == "education"]';
    client
      .fetch(query)
      .then((data) => {
        console.log(data);
        setEducation(data);
      })
      .catch((err) => console.log(err));
  }, []);
  return (
    <Container id="Education">
      <Wrapper>
        <Title>Education</Title>
        <Desc
          style={{
            marginBottom: '40px',
          }}
        >
          My education Has been a Journey of Self-Discovery and Growth. My
          educational details are as follows.
        </Desc>

        <VerticalTimeline>
          {education.map((education, index) => (
            <EducationCard key={`education-${index}`} education={education} />
          ))}
        </VerticalTimeline>
      </Wrapper>
    </Container>
  );
};

export default AppLearnMoreWrap(
  MotionWrap(Education),
  'education',
  'app__educationbg',
);
